
import React, { useEffect, useState } from "react";
import {
    Form,
    Row,
    Col,
    Button,
    Card,
    Modal,
} from "react-bootstrap";
export default function AddClassModal({
    showClassModal, setShowClassModal, newClass,
    classErrors, setNewClass, setClassErrors, closeClaessModal, saveClass
}) {
    return (
        <Modal show={showClassModal} onHide={() => setShowClassModal(false)} centered>
            <Modal.Header closeButton className="m-3">
                <Modal.Title>Class</Modal.Title>
            </Modal.Header>
            <Modal.Body className="m-3">
                <Form.Control
                    type="text"
                    placeholder="Class Name"
                    value={newClass}
                    isInvalid={!!classErrors.name}
                    onChange={(e) => {
                        setNewClass(e.target.value);

                        setClassErrors((prev) => ({
                            ...prev,
                            name: undefined,
                        }));
                    }}
                />

                <Form.Control.Feedback type="invalid">
                    {classErrors.name?.[0]}
                </Form.Control.Feedback>

                {classErrors.school_id && (
                    <div className="text-danger mb-2">
                        {classErrors.school_id[0]}
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className="m-3">
                <Button onClick={() => closeClaessModal()}>Close</Button>
                <Button onClick={saveClass}>Save</Button>
            </Modal.Footer>
        </Modal>
    )
}
